import { useEffect, useState, FunctionComponent, Dispatch, SetStateAction } from 'react'
import AccordionHeaderContainer from 'redux/containers/components/accordion/AccordionHeaderContainer'
import AccordionContainer from 'components/accordion/AccordionContainer'
import { GroupListItemContainerProps } from 'redux/containers/components/accordion/GroupListItemContainer'

const GroupListItem: FunctionComponent<GroupListItemProps> = ({
  props,
  state,
  expanded,
  isLoading,
  className,
  setAccordionExpandedNodeId,
  setAccordionExpandedNodeTitle,
  setAccordionBreadCrumbClicked
}) => {
  const [allContentExpanded, setAllContentExpanded] = useState(false)

  useEffect(() => {
    const { depth, id, title } = props
    if (depth === 1 && expanded) {
      setAccordionExpandedNodeId(id)
      setAccordionExpandedNodeTitle(title)
      setAccordionBreadCrumbClicked(false)
    }
  }, [expanded, props.depth, props.id, props.title])

  const { eventCategory, groupSource: { value } } = props
  const hideHeader = eventCategory === 'Legislation' && (value as boolean) && value.length === 1 && !(value[0].title as boolean)

  return (
    <li
      style={{ marginBottom: 0 }}
      className={className}
      id={props.id}
    >
      {!hideHeader && (
        <AccordionHeaderContainer
          {...props}
          {...state}
          {...{
            allContentExpanded,
            setAllContentExpanded,
            atBottom: 0,
            expanded: expanded && !isLoading
          }}
        />
      )}
      {expanded && !isLoading && (
        <Children
          props={props}
          state={state}
          {...{ allContentExpanded, setAllContentExpanded }}
        />
      )}
    </li>
  )
}

const Children: FunctionComponent<ChildrenProps> = ({ props, state, allContentExpanded = false, setAllContentExpanded }) => {
  const { aol, depth, enableHighlight, highlight, eventCategory, cxNames, title, hasAccess } = props
  const { group } = state

  return (
    <AccordionContainer
      {...{
        aol,
        parentTitle: eventCategory === 'Legislation' && title,
        depth: (depth as number) + 1,
        group,
        highlight: (enableHighlight as boolean) && (highlight as boolean) ? highlight : null,
        eventCategory,
        allContentExpanded,
        setAllContentExpanded,
        cxNames,
        hasAccess
      }}
    />
  )
}

interface ChildrenProps {
  state: any
  props: any
  allContentExpanded: boolean
  setAllContentExpanded: Dispatch<SetStateAction<boolean>>
}

interface GroupListItemProps extends GroupListItemContainerProps {
  state: any
  props: any
  expanded: boolean
  isLoading: boolean
  className: string
}

export default GroupListItem
